import React, { useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { MdClose, MdDelete } from "react-icons/md";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { workOutExerciseCreateInterface } from "../../api/types/types";
import { useGetExercises } from "../../api/useProducts/useExercises";
import { useCreateWorkOutExercises } from "../../api/useProducts/useWorkOut";
import { CustomButton, InputField, Sidebar } from "../../components";
import { TimePicker } from "antd";
import moment from "moment";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
// Form data interface
interface WorkoutFormData {
  exercises: { value: string; label: string };
  order: number;
  duration: number;
  level: { value: string; label: string };
  reps: number;
  sets: number;
}

const WorkoutExercises: React.FC = () => {
  const { id } = useParams();
  const { mutate, isPending } = useCreateWorkOutExercises(Number(id));
  const { exercisesData, exercisesLoading } = useGetExercises({
    page: 1,
    limit: 100000,
  });
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm<WorkoutFormData>();
  const [exerciseList, setExerciseList] = useState<WorkoutFormData[]>([]);
  const [isExerciseList, setIsExerciseList] = useState<boolean>(false);

  console.log(exerciseList);
  const handleSave: SubmitHandler<WorkoutFormData> = (data) => {
    // console.log("Form Submitted", data);
    // @ts-ignore
    data.duration = moment(data.duration.$d).format("HH:mm:ss");

    setExerciseList((prevList = []) => [...prevList, data]);
    reset();
    setIsExerciseList(false);
  };
  const handleDelete = (idx: number) => {
    const newExercise = exerciseList.filter((_, index) => index !== idx);
    console.log("🚀 ~ handleDelete ~ newExercise:", newExercise);
    setExerciseList(newExercise);
  };

  const handleSubmitExercise = () => {
    const formattedExercises: workOutExerciseCreateInterface[] =
      exerciseList.map((exercise) => ({
        sets: parseInt(exercise.sets as unknown as string),
        reps: parseInt(exercise.reps as unknown as string),
        order: parseInt(exercise.order as unknown as string),
        duration: `${exercise.duration}`,
        exerciseId: parseInt(exercise.exercises.value),
      }));
    console.log(formattedExercises, "formattedExercises");
    mutate(formattedExercises, {
      onSuccess: (data) => {
        toast.success("successfully created");
        navigate(`/workouts`);
      },
      onError: (error: any) => {
        toast.error(error.response.data.message);
      },
    });
  };
  const breadcrumbItems = [
    { title: "Workouts", link: "workouts" },
    { title: "Exercise " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      <div className="flex justify-between items-center my-2">
        <h1 className="font-medium mb-4 text-2xl">
          Workout Exercise{isExerciseList ? "" : "s"}
        </h1>
        {isExerciseList && (
          <CustomButton
            handleClick={() => setIsExerciseList(false)}
            icon={<MdClose size={22} />}
            rounded="rounded-full"
            padding="p-0"
            addclass="mt-4 ms-auto w-8 h-8"
          />
        )}
      </div>
      {!isExerciseList ? (
        <div>
          {exerciseList?.length > 0 ? (
            exerciseList?.map((value, idx) => {
              return (
                <div
                  key={idx}
                  className="border-2 border-darkCyan overflow-hidden rounded-lg p-4 mb-3 relative"
                >
                  <span
                    className="absolute top-0 end-0 cursor-pointer w-7 h-7 flex justify-center items-center rounded-bl-lg  bg-darkCyan text-white"
                    onClick={() => handleDelete(idx)}
                  >
                    <MdDelete size={20} />
                  </span>
                  <p className="font-semibold">
                    Reps :
                    <span className="text-gray-500 font-normal ms-1.5">
                      {" "}
                      {value?.reps}
                    </span>
                  </p>
                  <p className="font-semibold">
                    Sets :
                    <span className="text-gray-500 font-normal ms-1.5">
                      {value?.sets}{" "}
                    </span>
                  </p>
                  <p className="font-semibold">
                    Duration :
                    <span className="text-gray-500 font-normal ms-1.5">
                      {value?.duration}
                    </span>
                  </p>
                  <p className="font-semibold">
                    Exercises :
                    <span className="text-gray-500 font-normal ms-1.5">
                      {value?.exercises.label}
                    </span>
                  </p>
                  <p className="font-semibold">
                    Order :
                    <span className="text-gray-500 font-normal ms-1.5">
                      {value?.order}
                    </span>
                  </p>
                </div>
              );
            })
          ) : (
            <div
              onClick={() => setIsExerciseList(true)}
              className="border-2 border-darkCyan  border-dashed rounded-lg p-3 text-center mt-4 min-h-32 flex justify-center items-center"
            >
              <CustomButton
                handleClick={() => setIsExerciseList(true)}
                icon={<FaPlus size={25} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4  w-12 h-12"
              />
            </div>
          )}
          {exerciseList?.length >= 1 && (
            <div>
              <CustomButton
                handleClick={() => setIsExerciseList(true)}
                icon={<FaPlus size={25} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4 ms-auto w-12 h-12"
              />
            </div>
          )}
          <div>
            <CustomButton
              handleClick={handleSubmitExercise}
              isLoading={isPending}
              btntext="Submit"
              addclass={`mt-5 mx-auto w-1/2 ${
                exerciseList?.length === 0 && "bg-gray-400 cursor-not-allowed"
              }`}
            />
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(handleSave)}>
          <div>
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 ">
              <InputField
                label="Reps"
                placeholder="Enter reps"
                type="number"
                register={register(`reps`, {
                  required: "Reps are required",
                  validate: (value) => {
                    // @ts-ignore
                    if (value <= 0) {
                      return "reps must be a positive number";
                    }
                    // @ts-ignore
                    if (!Number.isInteger(parseFloat(value))) {
                      return "reps must be a whole number";
                    }
                    return true;
                  },
                })}
                error={errors.reps?.message}
              />
              <InputField
                label="Sets"
                placeholder="Enter set"
                type="number"
                register={register(`sets`, {
                  required: "Sets are required",
                  validate: (value) => {
                    // @ts-ignore
                    if (value <= 0) {
                      return "Sets must be a positive number";
                    }
                    // @ts-ignore
                    if (!Number.isInteger(parseFloat(value))) {
                      return "Sets must be a whole number";
                    }
                    return true;
                  },
                })}
                error={errors.sets?.message}
              />
              {/* <InputField
                label="Duration"
                placeholder="HH:MM"
                type="text"
                register={register("duration", {
                  required: "Duration is required",
                  pattern: {
                    value: /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/, // Regex to match HH:MM format
                    message: "Please enter a valid time in HH:MM format",
                  },
                })}
                error={errors.duration?.message}
              /> */}
              <div>
                <p className="block text-gray-700 mb-2">Duration</p>

                <Controller
                  name="duration"
                  control={control}
                  rules={{
                    required: "duration are required",
                    min: { value: 1, message: "duration must be at least 1" },
                  }}
                  render={({ field }) => (
                    // @ts-ignore
                    <TimePicker
                      {...field}
                      className="!focus:shadow-none w-full h-11 !focus:border-gray-300 hover:shadow-none hover:border-gray-300 text-sm"
                    />
                  )}
                />
                {errors.duration && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.duration.message}
                  </p>
                )}
              </div>

              <InputField
                label="order"
                placeholder="Enter order"
                type="number"
                register={register(`order`, {
                  required: "Order is required",
                  validate: (value) => {
                    // @ts-ignore
                    if (value <= 0) {
                      return "Order must be a positive number";
                    }
                    // @ts-ignore
                    if (!Number.isInteger(parseFloat(value))) {
                      return "Order must be a whole number";
                    }
                    return true;
                  },
                })}
                error={errors.order?.message}
              />

              <div>
                <p className="block text-gray-700 mb-2">Exercises</p>
                <Controller
                  name={`exercises`}
                  control={control}
                  rules={{ required: "Exercise is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isDisabled={exercisesLoading}
                      options={exercisesData?.data.map((exercise) => ({
                        value: exercise.id.toString(),
                        label: exercise.title,
                      }))}
                      placeholder="Select exercises"
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: "44px", // Background color for the select control
                          boxShadow: "none",
                          caretColor: "#24B1B3",
                          border: "1px solid #E5E7EB",
                          borderRadius: "8px",
                          fontSize: "14px",
                          "&:focus": {
                            outline: "none !important",
                            boxShadow: "none !important",
                            borderColor: "gray !important",
                          },
                          "&:hover": { borderColor: "none !important" },
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "rgb(148 163 184)", // Set placeholder color here
                        }),
                      }}
                    />
                  )}
                />
                {errors.exercises && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.exercises?.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          <CustomButton
            type="submit"
            isLoading={isPending}
            btntext="Save"
            addclass="mt-5 mx-auto w-1/2"
          />
        </form>
      )}
    </Sidebar>
  );
};

export default WorkoutExercises;
